<template>
  <div class="question-box">
    <div class="question-title">
      <span>{{index+1}}. </span>
      <span class="single-content" v-html="questionContent.content"></span>
      <span class="single-score">({{score}}分)</span>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="question-content-option">
      <div class="question-option" :class="isRight(1)">
        <el-radio name="answer" v-model="jugementAnswer" :label="1" disabled>正 确</el-radio>
      </div>
      <div class="question-option" :class="isRight(2)">
        <el-radio name="answer" v-model="jugementAnswer" :label="2" disabled>错 误</el-radio>
      </div>
    </div>
    <div class="question-answer" :class="is_right?'is-right':'is-wrong'">
      <span class="it-li">正确答案：{{analysisContent.answer==1?'正确':'错误'}}</span>
      <span class="it-li" v-if="is_right">{{name}}选对了</span>
      <span class="it-li" v-if="!is_right && jugementAnswer!==null">{{name}}错选了{{jugementAnswer==1?'正确':'错误'}}</span>
      <span class="it-li" v-if="!is_right && jugementAnswer===null">{{name}}未选择答案</span>
      <span class="it-li">+{{student_score}}分</span>
    </div>
    <div class="question-analysis" v-if="analysisContent.content">
      <span>答案解析:</span>
      {{analysisContent.content}}
      <viewer :images="analysisContent.file">
        <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'name'],
  data() {
    return {
      jugementAnswer: '',//答案
      optionsContent: [],
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData: function () {
      this.jugementAnswer = this.itemContent.student_answer
      this.titleId = this.itemContent.id
      this.optionsContent = this.itemContent.answer
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
      this.is_right = this.itemContent.right_and_wrong
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
    },
    isRight: function (index) {
      let cls = ''
      if (this.jugementAnswer == index) {
        if (this.jugementAnswer === this.analysisContent.answer) {
          cls += ' is-right'
        } else {
          cls += ' is-wrong'
        }
      }
      return cls
    }
  },
}
</script>

<style scoped="">
</style>